const transformBlockConfig = (rawConfig) => {
  if (!rawConfig || typeof rawConfig !== "object") {
    return {};
  }
  const transformed = {};
  Object.entries(rawConfig).forEach(([key, value]) => {
    if (key.startsWith("grid_") || key === "enabled") {
      return;
    }
    if (value === "true") {
      transformed[key] = true;
    } else if (value === "false") {
      transformed[key] = false;
    } else if (value === "null" || value === null) {
      transformed[key] = null;
    } else if (value === "undefined") {
      transformed[key] = void 0;
    } else if (typeof value === "string" && value.trim() !== "" && !isNaN(Number(value))) {
      transformed[key] = Number(value);
    } else {
      transformed[key] = value;
    }
  });
  return transformed;
};
const toCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};
const transformKeysToCamelCase = (config) => {
  const transformed = {};
  Object.entries(config).forEach(([key, value]) => {
    const camelKey = toCamelCase(key);
    transformed[camelKey] = value;
    if (camelKey !== key) {
      transformed[key] = value;
    }
  });
  return transformed;
};
const transformCompleteConfig = (rawConfig) => {
  const booleanTransformed = transformBlockConfig(rawConfig);
  return transformKeysToCamelCase(booleanTransformed);
};
export {
  toCamelCase,
  transformBlockConfig,
  transformCompleteConfig,
  transformKeysToCamelCase
};
//# sourceMappingURL=config-transformer.js.map
